import { UUID } from 'crypto'
import { LicenseUI } from '../../pages/users/model/LicenseUI'
import VehicleLicenseType from '../vehicle/VehicleLicenseType'
import { LicenseDto } from '../../pages/users/api/dto/get/LicenseDto'

class License {
  private constructor(
    id: UUID | undefined,
    studentId: UUID | undefined,
    vehicleLicense: VehicleLicenseType,
    examFailNumber: number,
    description: string | undefined,
    successDate: Date | undefined,
    renewalDate: Date | undefined,
    licenseProtocolNumber: string | undefined,
  ) {
    this.id = id
    this.studentId = studentId
    this.vehicleLicense = vehicleLicense
    this.examFailNumber = examFailNumber
    this.description = description ? description : ''
    this.successDate = successDate
    this.renewalDate = renewalDate
    this.licenseProtocolNumber = licenseProtocolNumber
      ? licenseProtocolNumber
      : ''
  }

  private readonly id?: UUID
  private readonly studentId?: UUID
  private readonly vehicleLicense: VehicleLicenseType
  private readonly examFailNumber: number
  private readonly description: string
  private readonly successDate?: Date
  private readonly renewalDate?: Date
  private readonly licenseProtocolNumber: string

  toLicenseUI(): LicenseUI {
    return {
      id: this.id,
      studentId: this.studentId,
      type: this.vehicleLicense.getType(),
      vehicleLicense: this.vehicleLicense,
      examFailNumber: this.examFailNumber,
      description: this.description,
      active: this.isActive(),
      restricted: this.isRestricted(),
      success: this.isSuccess(),
      successDate: this.successDate,
      renewalDate: this.renewalDate,
      licenseProtocolNumber: this.licenseProtocolNumber,
    } satisfies LicenseUI
  }

  hadVehicleId(id: string): boolean {
    return id === this.vehicleLicense.getId()
  }

  isActive(): boolean {
    return this.id !== undefined
  }

  isRestricted(): boolean {
    return false
  }

  isSuccess(): boolean {
    return this.successDate != null
  }

  static fromDto(
    studentId: UUID,
    licensesDto: LicenseDto[],
    vehicleLicense: VehicleLicenseType,
  ): License {
    const licenseDto = licensesDto.find((license: LicenseDto) =>
      vehicleLicense.hasId(license.type),
    )

    if (licenseDto !== undefined) {
      const {
        id,
        examFailNumber,
        description,
        successDate,
        renewalDate,
        licenseProtocolNumber,
      } = licenseDto

      return new License(
        id,
        studentId,
        vehicleLicense,
        examFailNumber,
        description,
        successDate != null ? new Date(successDate) : undefined,
        renewalDate != null ? new Date(renewalDate) : undefined,
        licenseProtocolNumber,
      )
    }

    return new License(
      undefined,
      undefined,
      vehicleLicense,
      0,
      undefined,
      undefined,
      undefined,
      undefined,
    )
  }
}

export default License
